export default __webpack_public_path__ + "static/media/clothing_other.e507bbb3.svg";